import React from "react";
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Image,
  Modal,
  PinInput,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";
import useStyles from "./style";
import { LuInfo } from "react-icons/lu";
import { useForm } from "@mantine/form";
import { PhoneInput } from "react-international-phone";
import swal from "sweetalert";
import success2FAIcon from "../../images/hugeiconsnoteremove.png";
import {
  resend2fa,
  staffAndProfile2fa,
  verify2fa,
  verifyTwoFactor,
} from "../../services";
import { getProfile } from "../../services/profile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mantine/hooks";
import { getStaffById } from "../../services/staff";
import { obfuscatePhone } from "../../utils";

const SetupTwoFactorModal = ({
  opened,
  close,
  profile,
  isSettingPage,
  staff,
  isNavbar,
  isStaffPage,
}) => {
  const isResponsive = useMediaQuery("(max-width: 992px)");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [otpscreen, setOtpscreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pendingPhone, setPendingPhone] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();
  const form = useForm({
    initialValues: {
      email: profile?.user?.email || "",
      phone: "",
    },
  });

  useEffect(() => {
    form.setFieldValue("email", profile?.user?.email || "");
  }, [profile]);
  const { classes } = useStyles();
  const successSetup = async () => {
    await swal({
      title: "Note:",
      text: "You will receive a SMS or Email with an authentication code every time when you log in.",
      icon: success2FAIcon,
      buttons: {
        confirm: {
          text: "OK",
          visible: true,
          className: classes.customokbutton,
        },
      },
      dangerMode: false,
    });
  };
  const resetPhoneSuccess = async () => {
    await swal({
      title: "Success!",
      text: "You have successfully reset your phone number for two-factor authentication.",
      icon: success2FAIcon,
      buttons: {
        confirm: {
          text: "OK",
          visible: true,
          className: classes.customokbutton,
        },
      },
      dangerMode: false,
    });
  };

  const handleVerify = async () => {
    try {
      setError("");

      if (otp?.length < 6) {
        setError("Please enter the complete 6-digit code.");
        return;
      }

      setVerifying(true);

      const values = {
        userId: staff ? staff.id : profile?.user.id,
        code: Number(otp),
        isNavbar: isNavbar ? true : false,
        phone: pendingPhone,
      };
      const res = await staffAndProfile2fa(values, navigate);

      if (res) {
        // navigate("/home");
        getProfile();
        form.reset();
        if (isSettingPage) {
          resetPhoneSuccess();
          setOtpscreen(false);
          form.reset();
          setOtp("");
        } else {
          successSetup();
          form.reset();
          setOtpscreen(false);
          navigate("/home/settings", { state: { selectedTab: "security" } });
          setOtp("");
        }
        //  if(isStaffPage){
        //     navigate("/home/staff");
        //     // await getStaffById(staff?.id);
        //   }
        // await getStaffById(staff.id);
        setLoading(false);
        close(); //
      }
    } catch (error) {
      setOtp("");
      setError("");
      setVerifying(false);
    } finally {
      setVerifying(false);
    }
  };

  const handleResend = async () => {
    try {
      setResendLoading(true);
      await resend2fa({
        userId: staff ? staff.id : profile?.user.id,
        pendingPhone: pendingPhone,
        reset: isSettingPage ? "isSettingPage" : "",
      });
    } catch (err) {
    } finally {
      setResendLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      const phone = values?.phone?.replace(/\D/g, "");

      if (!phone || phone.length < 8 || phone.length > 15) {
        await swal({
          title: "Invalid Phone Number",
          text: "Please enter a valid phone number in international format",
          icon: "warning",
          dangerMode: true,
        });
        return;
      }
      setLoading(true);
      // setOtpscreen(true)
      // Add your form submission logic here
      const payload = {
        userId: staff ? staff.id : profile?.user.id,
        phone: values.phone,
      };

      const res = await verifyTwoFactor(payload);
      if (res) {
        setPendingPhone(values.phone);
        if (isSettingPage) {
          setOtpscreen(true);
          setLoading(false);
        } else {
          setOtpscreen(true);
          setLoading(false);
        }
        setLoading(false);
        // getProfile();
        // setLoading(false);
        // form.reset();
        // close(); //
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setOtpscreen(false);
        form.reset();
        setPendingPhone("");
        setOtp("");
        close();
      }}
      centered
      size={690}
      shadow="md"
      radius={"lg"}
      zIndex={1000}
      overlayProps={{ blur: 3 }}
      classNames={{ header: classes.modalHeader }}
      className={classes.modalBody}
      title={
        // isSettingPage ? (
        //   <Text className={classes.modalTitle}>
        //     Reset phone number
        //     <LuInfo />
        //   </Text>
        // ) : (
          <Text className={classes.modalTitle}>
            Setup two-factor authentication
            <LuInfo />
          </Text>
        // )
      }
    >
      {/* RIGHT SIDE */}

      {otpscreen ? (
        <>
          <Grid className={classes.contentBoxParent}>
            <Grid.Col xs={12} sm={12} md={12} className={classes.contentBox}>
              <Box>
                {isResponsive && (
                  <Image
                    src="assets/images/logo2.png"
                    alt="logo"
                    width={150}
                    height={50}
                    fit="fill"
                  />
                )}

                <Text fz={28} ff={"Inter"} color="#262626" mb="md">
                  Two-Factor Authentication
                </Text>
                <Text fz={18} ff={"Inter"} color="#262626" mb="md">
                  We've sent a 6-digit verification code to{" "}
                  <b>
                    {/* {`*** *** ${form.values.phone
                      ?.replace(/\D/g, "")
                      .slice(-4)}`} */}
                    {obfuscatePhone(form.values.phone)}
                  </b>
                  .
                  <br />
                  Please enter it below to continue.
                </Text>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleVerify();
                  }}
                >
                  <Center>
                    <PinInput
                      length={6}
                      size="xl"
                      type="number"
                      oneTimeCode
                      value={otp}
                      onChange={setOtp}
                      placeholder="0"
                      classNames={{
                        input: classes.pinInput,
                      }}
                    />
                  </Center>

                  {error && (
                    <Text color="red" ta="center" ff="Inter" mt={10}>
                      {error}
                    </Text>
                  )}

                  <Button
                    fullWidth
                    size="md"
                    radius="md"
                    className={classes.login_btn}
                    // onClick={handleVerify}
                    loading={verifying}
                    type="submit"
                  >
                    {verifying ? "Verifying..." : "Verify Code"}
                  </Button>
                </form>
                {/* <Text ta="center" ff="Inter" fz={14} color="#344054" mt="sm">
            Note: After <b>5 incorrect attempts</b>, your account will be locked
            for <b>30 minutes</b>.
          </Text> */}

                <Flex
                  justify="center"
                  align="center"
                  gap={4}
                  className={classes.resendLinkText}
                >
                  <Text className="text">Didn’t receive the code?</Text>
                  <UnstyledButton className="resendLink" onClick={handleResend} disabled={resendLoading}>
                    {resendLoading ? "Resending..." : "Resend"}
                  </UnstyledButton>
                </Flex>
                <Flex justify="center" align="center" gap={4} mt={10}>
                  <UnstyledButton
                    className="resendLink"
                    onClick={() => {
                      setOtpscreen(false);
                      setOtp("");
                      form.reset();
                    }}
                  >
                    <Text fw={500} ff={"Inter"} className="text">
                      Change phone number again here
                    </Text>
                  </UnstyledButton>
                </Flex>
              </Box>
            </Grid.Col>
          </Grid>
        </>
      ) : (
        <>
          <Box className={classes.contentBoxParent}>
            <Box className={classes.contentBox}>
              {/* {isSettingPage ? (
                <Text className="infoText">
                  Reset phone number for two-factor authentication. You will
                  receive a SMS with an authentication code every time when you
                  log in.
                </Text>
              ) : ( */}
                <Text className="infoText">
                  Skypoint stores sensitive health information. To protect your
                  clients and stay compliant, we require an extra step to verify
                  your identity when logging in.
                </Text>
              {/* )} */}

              <form onSubmit={form.onSubmit(handleSubmit)}>
                <Grid maw={480} w="100%" gutter={15} mx="auto">
                  <Grid.Col span={12}>
                    {!isSettingPage && (
                      <TextInput
                        label="Email:"
                        placeholder="Enter Email:"
                        className={classes.inputField}
                        {...form.getInputProps("email")}
                        readOnly
                      />
                    )}
                  </Grid.Col>
                  <Grid.Col span={12}>
                    <Text className={classes.phoneLabel}>Phone number:</Text>
                    <PhoneInput
                      defaultCountry="us"
                      placeholder="Enter phone number"
                      className={classes.phoneInputWrapper}
                      disableFormatting={false}
                      forceDialCode={true}
                      showDisabledDialCode={true}
                      autoFocus
                      {...form.getInputProps("phone")}
                    />
                  </Grid.Col>
                </Grid>
                <Box mt={30}>
                  <Flex justify="flex-end">
                    <Button
                      type="submit"
                      radius={"md"}
                      color="yellow"
                      c={"#000"}
                      loading={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>
                  </Flex>
                </Box>
              </form>
            </Box>
          </Box>
        </>
      )}
    </Modal>
  );
};

export default SetupTwoFactorModal;
